import React from "react";
import { Snackbar, Button, IconButton } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import CloseIcon from "@material-ui/icons/Close";
import { IStyledArguments } from "../../types/styled-arguments";

const StyledSnackbar = styled(Snackbar)(({ theme }: IStyledArguments) => ({
  "& .MuiSnackbarContent-root": {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    fontSize: "0.9rem",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    borderRadius: "8px",
    padding: theme.spacing(1.5, 2),
  },
}));

const UpdateButton = styled(Button)(({ theme }: IStyledArguments) => ({
  color: "#fff",
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(1),
  fontWeight: 600,
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.3)",
  },
}));

interface IUpdateNotificationProps {
  open: boolean;
  onUpdate: () => void;
  onClose: () => void;
}

export default function UpdateNotification({
  open,
  onUpdate,
  onClose,
}: IUpdateNotificationProps) {
  return (
    <StyledSnackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={open}
      message="Nueva versión disponible"
      action={
        <>
          <UpdateButton size="small" onClick={onUpdate}>
            Actualizar
          </UpdateButton>
          <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
}
